exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".send-tip-modal .creator-control[data-v-5880f3a3] {\n  margin-bottom: 24px;\n}\n", ""]);

// exports
